<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 18:13:11
 * @Description: 二次认证
-->
<template>
	<div class="second_auth">
		<div class="container">
			<div class="title">{{ $t("login.second_auth.title") }}</div>

			<div class="tips">
				<a-alert :message="$t('login.second_auth.tip')" type="warning" show-icon />
			</div>

			<a-form-model :model="form" ref="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
				<a-form-model-item :label="$t('login.second_auth.label')" prop="type">
					<a-select
						v-model="form.type"
						:placeholder="$t('login.second_auth.placeholder')"
						:disabled="safeSetInfo.sfyxqhrzfs == 2"
						@change="selectChange"
					>
						<template v-for="item in authList">
							<a-select-option :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
						</template>
					</a-select>
				</a-form-model-item>
				<template v-if="form.type == 1">
					<a-form-model-item :label="$t('base.mobile.label')" prop="sjh">
						<span>{{ user.mobile }}</span>
					</a-form-model-item>
					<a-form-model-item :label="$t('base.captcha.label')" class="form_flex" prop="value">
						<a-input v-model="form.value" :placeholder="$t('base.captcha.placeholder')"></a-input>
						<div class="codeBox">
							<a-button v-if="count == 60" type="primary" @click="handleCode(2)">{{ $t("base.btn.get_code") }}</a-button>
							<a-button type="primary" disabled v-else>{{ count }}s</a-button>
						</div>
					</a-form-model-item>
				</template>
				<!-- <template v-if="form.type == 2">
					<a-form-model-item label="企业微信号" prop="value">
						<span>xxxxxx</span>
					</a-form-model-item>
				</template>
				<template v-if="form.type == 3">
					<a-form-model-item label="支付宝人脸识别" prop="value">
						<span>支付宝人脸识别</span>
					</a-form-model-item>
				</template> -->
				<template v-if="form.type == 4">
					<a-form-model-item :label="$t('login.second_auth.password_label')" prop="value">
						<a-input-password v-model="form.value" :placeholder="$t('login.second_auth.password_placeholder')"></a-input-password>
					</a-form-model-item>
				</template>
				<template v-if="form.type == 5">
					<a-form-model-item :label="$t('base.email.label')" prop="sjh">
						<span>{{ user.email }}</span>
					</a-form-model-item>
					<a-form-model-item :label="$t('base.captcha.label')" class="form_flex" prop="value">
						<a-input v-model="form.value" :placeholder="$t('base.captcha.placeholder')"></a-input>
						<div class="codeBox">
							<a-button v-if="count == 60" type="primary" @click="handleCode(1)">{{ $t("base.btn.get_code") }}</a-button>
							<a-button type="primary" disabled v-else>{{ count }}s</a-button>
						</div>
					</a-form-model-item>
				</template>
			</a-form-model>

			<div class="footer">
				<a-button @click="goLogin">{{ $t("base.btn.back_login") }}</a-button>
				<a-button type="primary" @click="handleOk">{{ $t("base.btn.sure") }}</a-button>
			</div>
		</div>
	</div>
</template>

<script>
import { commonMethods } from "../mixins/common";
import { mapGetters } from "vuex";
import { commonAPI } from "@/apis";

export default {
	name: "SecondAuth",
	mixins: [commonMethods],
	data() {
		return {
			form: { type: "", value: "" },
			defaultAuth: [
				{ value: "1", name: this.$t("login.second_auth.auth_list.one") },
				{ value: "2", name: this.$t("login.second_auth.auth_list.two") },
				{ value: "3", name: this.$t("login.second_auth.auth_list.three") },
				{ value: "4", name: this.$t("login.second_auth.auth_list.four") },
				{ value: "5", name: this.$t("login.second_auth.auth_list.five") },
			],
			authList: [],
			rules: {
				type: [{ required: true, message: this.$t("login.second_auth.placeholder") }],
				value: [{ required: true, message: this.$t("base.captcha.placeholder") }],
			},
			safeSetInfo: {},
			before_login: {},
			count: 60,
		};
	},
	computed: {
		...mapGetters("auth", ["user"]),
	},
	beforeRouteEnter(to, form, next) {
		next((vm) => {
			// 判断是否可进入该路由
			let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
			if (!before_login || !before_login.secAuth) {
				vm.$router.replace({ path: form.path });
			} else {
				vm.before_login = { ...before_login };
			}
		});
	},
	created() {
		// 获取安全配置
		let safeSetInfo = sessionStorage.getItem("SAFE_SET_INFO");
		this.safeSetInfo = safeSetInfo ? JSON.parse(safeSetInfo) : {};

		this.defaultAuth.forEach((el) => {
			let flag = this.safeSetInfo.yxecrzfs.includes(el.value);
			if (flag) {
				this.authList.push(el);
			}
		});
		this.form.type = this.authList.length ? this.authList[0].value : undefined;
	},
	methods: {
		// 切换方式
		selectChange(value) {
			this.$refs.form.resetFields();
			this.form.type = value;
			this.form.value = "";
		},
		// 获取验证码
		async handleCode(type) {
			let params = {
				noticeClassify: type,
				businessClassify: "sec_auth",
				account: type == 1 ? this.user.email : this.user.mobile,
			};
			const { code, message } = await commonAPI.getAction("send/msg/sendCaptcha", params);
			if (code == 0) {
				this.$message.success(message);
				// 开启倒计时
				this.count--;
				const timer = setInterval(() => {
					if (this.count > 0 && this.count <= 60) {
						this.count--;
					} else {
						this.count = 60;
						clearInterval(timer);
					}
				}, 1000);
			} else {
				this.$message.error(message);
			}
		},
		// 确认
		handleOk() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					let params = { classify: this.form.type, val: this.form.value };
					(async () => {
						const { code, message } = await commonAPI.postAction(`/users/secCertification/${this.user.username}`, params);
						if (code == 0) {
							this.$message.success(message);
							this.before_login.secAuth = false;
							sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(this.before_login));
							this.jumpComputed();
						} else {
							this.$message.warning(message);
						}
					})();
				} else {
					return false;
				}
			});
		},
	},
};
</script>

<style lang="less" scoped>
.second_auth::v-deep {
	width: 100%;
	height: 100%;
	padding-top: 35px;
	.container {
		max-width: 800px;
		width: 80%;
		margin: 0 auto;
		background-color: #fff;
		padding: 30px 0;
		border-radius: 20px;
		.title {
			font-size: 22px;
			text-align: center;
			margin-bottom: 20px;
		}
		.tips {
			padding: 0 35px;
			margin-bottom: 30px;
		}
	}
	.form_flex .ant-form-item-children {
		display: flex;
		height: 42px;
		align-items: center;
		justify-content: space-between;

		.ant-input {
			flex: 1;
		}

		.codeBox {
			width: 100px;
			margin-left: 12px;
			& > * {
				width: 100%;
			}
		}
	}

	.footer {
		text-align: center;
		margin-top: 10px;
		.ant-btn + .ant-btn {
			margin-left: 40px;
		}
	}
}
</style>
